import type { PropsWithChildren } from 'react';

import React, { useContext, useRef } from 'react';

import ChatInterfaceComponent from '@Hub/Owlbot/Chat';

import { ProjectContext } from '@core/context';
import useClassy from '@core/hooks/useClassy';
import useDeferForHydrationMismatch from '@core/hooks/useDeferForHydrationMismatch';
import { useSuperHubStore } from '@core/store';
import { classy } from '@core/utils/classy';
import { ScrollTargetProvider } from '@core/utils/ScrollTarget';

import classes from './index.module.scss';

export default function ContentWithOwlbot({ children }: PropsWithChildren) {
  const bem = useClassy(classes, 'ContentWithOwlbot');
  const { project } = useContext(ProjectContext);
  const ref = useRef<HTMLDivElement | null>(null);

  const [isOwlbotOpenCached, isInSuperHubAdminView, toggleOwlbot] = useSuperHubStore(s => [
    s.isOwlbotOpenCached,
    s.user.role === 'admin' || s.user.role === 'editor', // SuperHub admin/editor views have taller header
    s.toggleOwlbot,
  ]);

  const isOpen = useDeferForHydrationMismatch(
    isOwlbotOpenCached && project?.owlbot?.enabled && project?.owlbot?.newExperience,
  );

  return (
    <ScrollTargetProvider scrollRef={ref}>
      <div className={bem('&', isOpen && '_with-sidebar', isInSuperHubAdminView && '_superhub')}>
        <div ref={ref} className={bem('-content')}>
          {children}
        </div>

        {!!(project?.owlbot?.enabled && project?.owlbot?.newExperience) && (
          <div className={classy(bem('-sidebar'), 'rm-AskAi-sidebar')}>
            {!!isOpen && <ChatInterfaceComponent onClose={toggleOwlbot} />}
          </div>
        )}
      </div>
    </ScrollTargetProvider>
  );
}
